"use client";

import { UiContainer, UiHeading } from "@frontend/roz-uikit";

import TechWork from "@/assets/img/500.png";

export const MaintenanceBanner = () => (
  <UiContainer className="sdkui:flex sdkui:min-h-[50vh] sdkui:flex-col sdkui:items-center sdkui:justify-center">
    <UiHeading align="center" className="mb-2" size="h2">
      Ведутся технические работы. <br />
      Пожалуйста, зайдите позже.
    </UiHeading>
    <div
      aria-label="Ведутся технические работы"
      className="sdkui:aspect-[643/150] sdkui:w-full sdkui:max-w-[643px] sdkui:bg-center sdkui:bg-contain sdkui:bg-no-repeat"
      role="img"
      style={{ backgroundImage: `url(${TechWork})` }}
    />
  </UiContainer>
);
